import React, { useState, useEffect } from "react";
import axios from "axios";
import "react-image-lightbox/style.css";


const RecentGallery = () => {
    const [imagePaths, setImagePaths] = useState([]);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);
    useEffect(() => {
        axios
            .get("https://online.funforay.com/admin/public/api/gallery")
            .then((res) => {
                if (res.data.status) {
                    const imgs = res.data.data.map((item) => item.image);

                    imgs.forEach((src) => {
                        const image = new Image();
                        image.src = src;
                    });

                    setImagePaths(imgs);
                }
            })
            .catch(console.log);
    }, []);

    return (
       <section className="gallery">
    <h2 className="gallery_title">Make Your Tour More Pleasure</h2>
    <h2 className="gallery_subtitle">Recent Gallery</h2>

    <div className="masonry-gallery">
        {imagePaths.map((img, index) => (
            <div
                key={index}
                className="masonry-item"
            >
                <img
                    src={img}
                    alt={`Gallery ${index + 1}`}
                    className="masonry-image"
                />
            </div>
        ))}
    </div>
</section>
    );
};

export default RecentGallery;